import { JSX } from "react";
import cx from "classnames";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";

interface SpecialtyPredictionModelProps {
  specialtyPredictionModel?: string[];
  className?: string;
  testId: string;
}

/**
 * SpecialtyPredictionModel component
 * This component displays the specialty model predictions for a provider.
 */
const SpecialtyPredictionModel = (props: SpecialtyPredictionModelProps): JSX.Element => {
  return (
    <div
      className={cx({ [props.className]: !!props.className, "data-box": true })}
      data-testid={props.testId}
    >
      <div className="data-box-header">
        Specialty Model Prediction
      </div>
      <div className="data-box-content">
        {props.specialtyPredictionModel?.length ? props.specialtyPredictionModel.map((tp, index) => (
          <EllipsisTooltip
            key={index}
            text={tp}
          />
        )) : "No Data is Available"}
      </div>
    </div>
  );
};

export default SpecialtyPredictionModel;